<template>
  <div class="shimmer-container" :style="containerStyle">
    <div v-for="n in lines" :key="n" class="shimmer-line-container">
      <div v-if="showAvatar" class="shimmer-circle"></div>
      <div class="shimmer-line" :style="lineStyle"></div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class LinesShimmer extends Vue {
  @Prop({ default: 3 }) readonly lines!: number;
  @Prop({ default: false }) readonly showAvatar!: boolean;
  @Prop({ default: 'rgba(0, 0, 0, 0.1)' }) readonly backgroundColor!: string;
  @Prop({ default: '1rem' }) readonly lineHeight!: string;
  @Prop({ default: undefined }) customStyles!: Record<string, string> | undefined;

  get containerStyle() {
    return this.customStyles
      ? this.customStyles
      : {
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
          backgroundColor: this.backgroundColor,
          padding: '0.4rem',
          borderRadius: '0.4rem'
        }
  }

  get lineStyle() {
    return {
      flex: 1,
      marginLeft: this.showAvatar ? '8px' : 0,
      backgroundColor: '#f6f7f8',
      borderRadius: '0.75rem',
      height: this.lineHeight
    }
  }
}
</script>

<style scoped>
.shimmer-container {
  width: 100%;
}

.shimmer-line-container {
  display: flex;
  align-items: center;
}

.shimmer-circle {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #f6f7f8;
  position: relative;
}

.shimmer-line {
  overflow: hidden;
  position: relative;
  width: 100%;
  background-color: #f6f7f8;
}

.shimmer-circle::after, .shimmer-line::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, #f6f7f8 0%, #edeef1 50%, #f6f7f8 100%);
  background-repeat: no-repeat;
  background-size: 800px 104px;
  animation: shimmerAnimation 1.5s infinite linear;
  border-radius: 10px;
}

@keyframes shimmerAnimation {
  0% {
    background-position: -800px 0;
  }
  100% {
    background-position: 800px 0;
  }
}

@media (max-width: 600px) {
  .shimmer-circle::after, .shimmer-line::after {
    background-size: 400px 104px;
  }
}
</style>
